export default __webpack_public_path__ + "static/media/Gloves of the Clay.f87a9810.jpg";